"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnqueueInput = void 0;
const ajv_1 = __importDefault(require("ajv"));
const enqueueInput_schema_json_1 = __importDefault(require("./enqueueInput.schema.json"));
const ajv = new ajv_1.default();
const validator = ajv.compile(enqueueInput_schema_json_1.default);
function isEnqueueInput(input) {
    const target = JSON.parse(JSON.stringify(input));
    const valid = validator(target);
    return !!valid;
}
exports.isEnqueueInput = isEnqueueInput;
//# sourceMappingURL=ICanEnqueue.js.map